export const TAMANHOS_COLUNA_CARD_RESERVA = {
  COLUNA_TITULO_SEM_COMISSIONADO: 2,
  COLUNA_TITULO_COM_COMISSIONADO: 3,
  COLUNA_DATA_COM_COMISSIONADO: 1,
  COLUNA_DATA_SEM_COMISSIONADO: 2,
  COLUNA_GRUPO_SEM_COMISSIONADO: 2,
  COLUNA_GRUPO_COM_COMISSIONADO: 1
}
export const QUANTIDADE_COTAS_PADRAO = 1
